export default "__VITE_ASSET__DtMv8JXF__"